import { motion } from "framer-motion";

const companyInfo = [
  { label: "会社名", value: "合同会社YY", icon: "ri-building-line" },
  { label: "代表者", value: "代表社員 荒木 義幸", icon: "ri-user-line" },
  { label: "事業内容", value: "飲食店・バーの運営", icon: "ri-briefcase-line" },
  { label: "運営店舗", value: "bar bebe", icon: "ri-store-2-line" },
  {
    label: "所在地",
    value: "北海道札幌市中央区\n南4条西5丁目 第二観光会館ビル 6F",
    icon: "ri-map-pin-line",
  },
];

export default function CompanySection() {
  return (
    <section id="company" className="relative w-full py-20 md:py-32 bg-warm-900">
      <div className="max-w-[1000px] mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="mb-10 md:mb-14"
        >
          <span className="inline-block px-4 py-1.5 text-xs md:text-sm font-sans font-medium tracking-super-wide text-warm-400 bg-warm-800 border border-warm-700 rounded-full mb-4">
            COMPANY
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-warm-100">
            運営会社情報
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="rounded-2xl border border-warm-800 divide-y divide-warm-800 overflow-hidden"
        >
          {companyInfo.map((item) => (
            <div
              key={item.label}
              className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-6 px-6 py-5 md:px-8 md:py-6"
            >
              <div className="flex items-center gap-3 sm:w-40 flex-shrink-0">
                <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-warm-800 flex items-center justify-center">
                  <i className={`${item.icon} text-amber-500 text-base`} />
                </div>
                <p className="text-xs md:text-sm font-sans text-warm-400">
                  {item.label}
                </p>
              </div>
              <p className="text-sm md:text-base font-sans text-warm-100 leading-relaxed whitespace-pre-line">
                {item.value}
              </p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
